<template>
	<el-container
		class="userManagement-box"
		v-loading="loading"
		direction="vertical"
	>
		<el-tabs
			v-model="activeName"
			v-if="!loading && !noData"
			@tab-click="handleClick"
		>
			<el-tab-pane label="健康评估" name="health">
				<router-view v-if="activeName == 'health'" />
			</el-tab-pane>
			<el-tab-pane label="体检信息" name="report">
				<router-view v-if="activeName == 'report'" />
			</el-tab-pane>
			<el-tab-pane label="基本信息" name="basic">
				<BasicInfo v-if="activeName == 'basic'" />
			</el-tab-pane>
			<el-tab-pane label="服务使用记录" name="record">
				<Examination ref="examination" v-if="activeName == 'record'" />
			</el-tab-pane>
		</el-tabs>
		<el-empty
			class="empty"
			v-if="noData"
			description="暂无档案信息"
		></el-empty>
	</el-container>
</template>
<script>
	import BasicInfo from "./components/BasicInfo";
	import Examination from "./components/Examination";
	import HealthAssessment from "./health/HealthAssessment";
	import ReportInfo from "./components/ReportInfo";
	export default {
		name: "UserDetail",
		components: {
			BasicInfo,
			Examination,
			HealthAssessment,
			ReportInfo,
		},
		data() {
			return {
				activeName: "health",
				loading: true,
				noData: null,
			};
		},
		watch: {
			$route(value, s) {
				if (
					s.name != "健康档案D" &&
					value.name == "健康档案D" &&
					this.activeName != "record"
				) {
					this.activeName = "health";
				}
			},
		},
		created() {
			this.$store.state.healthDocUser =
				JSON.parse(sessionStorage.getItem("health-user")) ||
				this.$store.state.healthDocUser;
			this.$root.breadList = [];
			this.activeName = this.$route.query.type
				? this.$route.query.type
				: "health";
			this.getUserProfileId();
		},
		methods: {
			handleClick(tab, event) {
				let query = {
					type: this.activeName,
				};
				switch (this.activeName) {
					case "report":
						this.$router.push({ name: "体检基础信息D", query });
						break;
					case "basic":
					case "record":
						this.$router.push({ name: "UserHealthInfo", query });
						break;
					case "health":
						this.$router.push({ name: "健康档案D", query });
						break;
				}
			},
			/**
			 * 获取数据
			 */
			async getUserProfileId(resetPage) {
				this.loading = true;
				let res = await this.axios.get(this.getApiUrl("userProfileId"), {
					params: {},
				});
				this.loading = false;
				if (res.data) {
					this.$store.state.healthDocUser.profileId =
						res.data.profileId || "";
					this.$store.state.healthDocUser.detailUserItem.sex =
						res.data.gender || "未知";
					this.$store.state.healthDocUser.userId = res.data.userId;
					this.$store.state.healthDocUser.isDoc = true;
					sessionStorage.setItem(
						"health-user",
						JSON.stringify(this.$store.state.healthDocUser)
					);
					this.$router.push({
						name: "健康档案D",
						query: { type: "health" },
					});
					this.noData = false;
				} else {
					this.noData = true;
				}
			},
		},
	};
</script>
<style lang="scss">
	.userManagement-box {
		position: relative;
		.back {
			position: absolute;
			right: 0;
			top: 0px;
		}
		.empty {
			padding-top: 150px;
		}
	}
</style>